import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {throwError as observableThrowError, Observable} from 'rxjs';
import {map} from 'rxjs/operators';

@Injectable()
export class ComponentesConfigService {

  private componentesUrl = 'assets/data/componentes.json';

  constructor(private _http: HttpClient) {
  }

  getComponentes(): Observable<any[]> {
    return this._http.get(this.componentesUrl)
      .pipe(map((data) => {
        return <any>data;
      }));
  }

  private handleError(error) {
    return observableThrowError(error.json().error || 'Server error');
  }
}
